import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService, ServerError } from '@radsource/ng-common-lib';

import { SOPInstance } from '../../objects/sop-instance';
import { StudyInstance } from '../../objects/study-instance';
import { InstanceService } from '../../services/instance.service';
import { DicomService } from '../../services/dicom.service';

import { of } from 'rxjs'

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'sop',
  templateUrl: './sop.component.html',
  styleUrls: ['./sop.component.scss']
})
export class SOPComponent implements OnInit, AfterViewInit {

  @Input() sop: SOPInstance;
  @Output() emitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() patientContainer: any;

  //UI Variables
  detail: Boolean = false;
  detail$: any;

  constructor(
    public is: InstanceService,
    public domSanitizer: DomSanitizer,
    public ms: MessageService,
    public ds: DicomService
  ) { }


  ngOnInit() {

    this.is.clearSOPDetails$.subscribe(event => { 
      this.detail = false; 
      this.detail$ = of(this.detail);
    });

    this.is.cmoveSOPDetail$.subscribe(event => {
      if (event && event.record_id == this.sop.record_id) {
        this.detail = true;
        this.detail$ = of(this.detail);
      }
    });
  }
  
  ngAfterViewInit() {
    // setTimeout(() => this.getThumbnail(), 0);
    if (this.ds.pushing == false && this.ds.pushAttempted == false) {
      this.getThumbnail();
    }
  }

  cleanURL() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl('data:' + this.sop.thumbnail.mimeType + ';' + this.sop.thumbnail.encoding + ',' + this.sop.thumbnail.image);
  }

  setDetail(): void {
    this.emitter.emit(this.sop);
  }
  
  getThumbnail() {
    if (this.sop.thumbnail) {
      return;
    }
    // this.sop.loadingThumbnail = true;
    this.is.retrieveSOPThumbnailAsOwner(this.sop.record_id, this.patientContainer.nativeElement.offsetHeight)
      .then((res) => {
        if (res.error.length > 0) {
          throw Error(res.error);
        }
        this.sop.thumbnail = res;
        this.sop.thumbnail$ = of(this.sop.thumbnail);
        // this.sop.loadingThumbnail = false;
      }).catch((err) => {
        this.ms.handleServerError(new ServerError(err));
      });
  }

  viewDetail(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.is.clearSOPDetails$.emit();
    let allStudies = this.is.patients.reduce((accumulator, currentValue) => {
      return [...accumulator, ...currentValue.studies];
    }, []);
    this.sop.study = allStudies.find((s: StudyInstance) => s.record_id == this.sop.study.record_id);
    this.is.cmoveSOPDetail = this.sop;
    this.is.cmoveSOPDetail$.emit(this.is.cmoveSOPDetail);
  }
}
